import * as c from 'common/c'

// `harvestIds` names the loaded harvests the legend actually applies to, so the
// reducer can scope its fan-out. Omitted by callers that have no harvest context;
// the reducer falls back to its previous behaviour then.
export const legendCreated = (data, harvestIds?: number[]) => {
  return {
    type: c.LEGEND_CREATED,
    payload: data,
    meta: { harvestIds },
  }
}

export const legendsFetched = (data) => {
  return {
    type: c.CUSTOM_LEGENDS_FETCHED,
    payload: data,
  }
}
export const legendDeleted = (data, meta) => {
  return {
    type: c.CUSTOM_LEGEND_DELETED,
    payload: data,
    meta: meta,
  }
}

export const updateCropLegend = (data, harvestIds) => {
  return {
    type: c.CROP_LEGEND_UPDATED,
    payload: { data, harvestIds },
  }
}
